import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IProfile } from '@boma/supplier-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class AuthedUserService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadUser() {
    return this.httpClient.get<IProfile>(
      `${this.base}api/v${this.version}/Profiles/me`
    );
  }
}
